export const isDebug = () =>
  process.env.NODE_ENV !== "production" && (window as any).cb_debug === true;

export const dlog = (...args: any[]) => {
  if (isDebug()) console.log(...args);
};
